import React from 'react'
import classnames from 'classnames'

interface Props {
  type?: 'submit' | 'button'
  as?: any
  to?: string
  disabled?: boolean
  submitting?: boolean
  onClick?: any
  style?: React.CSSProperties
  className?: string
  children: React.ReactNode
  cancel?: boolean
}

const Button = (props: Props): JSX.Element => {
  const {
    type = 'button',
    disabled,
    submitting,
    onClick,
    style,
    className,
    children,
    cancel,
    as: Component = 'button',
    ...rest
  } = props

  return (
    <Component
      type={Component === 'button' ? type : undefined}
      onClick={onClick}
      disabled={disabled ?? submitting}
      style={style}
      className={classnames(
        'inline-block w-full text-center font-medium text-lg rounded border-none cursor-pointer transition-all duration-200 ease-in-out',
        {
          // Primary button (king-red)
          'bg-king-red text-white px-10 py-5 hover:bg-king-red-800': !cancel,
          // Cancel button (king-blue outline)
          'bg-white text-king-blue px-10 py-5 hover:text-king-blue-800': cancel,
          // Disabled state
          'opacity-50 pointer-events-none': disabled || submitting,
        },
        className
      )}
      {...rest}
    >
      {submitting === true ? (
        <div className="flex items-center justify-center">
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <span>{children}</span>
        </div>
      ) : (
        children
      )}
    </Component>
  )
}

export default Button
